import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Button,
  Typography,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from "@mui/material";
import { ModalBox } from "../../../styles/ModalStyles";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getTipoDocumentoHabilitado } from "../../http/actions/TipoDocumentoAction";
import CheckboxGroup from "../../data/CheckBox";

const AgregarRelacionOrganismoTipoDocumentoModal = ({ open, onClose, onSubmit, organismo }) => {
  const [tipos, setTipos] = useState([]);
  const [selectedTipos, setSelectedTipos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (open && organismo) {
      fetchTipos();
      if (organismo.idTipoDocumento && organismo.idTipoDocumento.length > 0) {
        setSelectedTipos(organismo.idTipoDocumento);
      } else {
        setSelectedTipos([]);
      }
    }
  }, [open, organismo]);

  const fetchTipos = () => {
    setIsLoading(true);
    getTipoDocumentoHabilitado(localStorage.getItem("token"))
      .then((response) => {
        setTipos(Array.isArray(response) ? response : []);
      })
      .catch((error) => {
        console.log(error);
        setTipos([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleCheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSelectedTipos(prev => 
      checked 
        ? [...prev, id]
        : prev.filter(item => item !== id)
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({
      idOrganismoEmisor: organismo.id,
      idTipoDocumento: selectedTipos
    });
  };

  const handleClose = () => {
    setSelectedTipos([]);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalBox sx={{ width: '90%', maxWidth: 800, maxHeight: '90vh', overflow: 'auto' }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant='h6' sx={{ mb: 3 }}>
          Gestionar Tipos de Documento
        </Typography>
        
        <Typography variant="subtitle1" sx={{ color: 'text.secondary', mb: 1 }}>
          Organismo: {organismo?.nombre}
        </Typography>
        
        <Typography variant="body2" sx={{ mb: 3 }}>
          Seleccione los tipos de documento asociados a este organismo emisor.
        </Typography>
        
        <form onSubmit={handleSubmit}>
          {/* Tipos de Documento */}
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">Tipos de Documento Disponibles</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {isLoading ? (
                <Box display="flex" justifyContent="center" p={3}>
                  <Typography>Cargando tipos de documento...</Typography>
                </Box>
              ) : (
                <Grid container spacing={2}>
                  <CheckboxGroup
                    title="Tipos de Documento"
                    items={tipos}
                    selectedItems={selectedTipos}
                    onChange={handleCheckboxChange}
                    name="tipos"
                  />
                </Grid>
              )}
            </AccordionDetails>
          </Accordion>

          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary"
              disabled={isLoading}
            >
              Guardar cambios
            </Button>
            <Button onClick={handleClose} variant="contained" color="error">
              Cancelar
            </Button>
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default AgregarRelacionOrganismoTipoDocumentoModal;